export const de = {
  // ── StartScreen ──────────────────────────────────────────
  "start.title": "SOLITAIRE",
  "start.setOfDay": "Set des Tages",
  "start.setOfDay.sub": "Klassisches Klondike — ein Set nach dem anderen",
  "start.journey": "Die ewige Reise",
  "start.journey.sub": "Spiele dich durch die Sets — Set für Set",
  "start.draw1": "Ziehe 1",
  "start.weekly": "Weekly",
  "start.weekly.sub": "Wöchentliche Liga — bald verfügbar",
  "start.tower": "Tower of Babel",
  "start.tower.sub": "Endlos-Solitaire — bald verfügbar",
  "start.klondike": "Klondike",
  "start.klondike.sub": "Ziehe 3 Karten",
  "start.soon": "Bald",

  // ── GamePage ─────────────────────────────────────────────
  "game.settings": "Einstellungen",
  "game.logout": "Abmelden",
  "game.graphicSettings": "Grafik-Einstellungen",
  "game.login": "Anmelden",
  "game.pts": "Pkt.",
  "game.undoLimitReached": "Undo-Limit erreicht ({{limit}}×)",
  "game.undoCount": "Zurück ({{used}}/{{limit}})",
  "game.undoMove": "Zug rückgängig",
  "game.retryTitle": "Dieses Set nochmal spielen (ohne Auswertung)",
  "game.retry": "Nochmal",
  "game.nextSetTitle": "Nächstes Set",
  "game.nextSet": "Nächstes ›",
  "game.endTitle": "Set beenden und Auswertung anzeigen",
  "game.end": "Ende",
  "game.leaderboardTitle": "Rangliste für dieses Set",
  "game.homeTitle": "Zurück zur Startseite",
  "game.helpTitle": "Hilfe zum Spielmodus",
  "game.helpClose": "Schließen",
  "game.helpDaily": "Set des Tages\n\nJeden Tag gibt es ein neues Set, das alle Spieler lösen. Vergleiche dich über die Rangliste mit anderen!\n\nTippe eine Karte an, um sie auszuwählen, dann tippe das Ziel an. Oder ziehe Karten per Drag & Drop auf passende Stapel.\n\nZiel: Lege alle 52 Karten sortiert nach Farbe (Ass → König) auf die vier Foundation-Stapel.",
  "game.helpJourney": "Die ewige Reise\n\nSpiele dich Schritt für Schritt durch die Sets — von Set 1 aufwärts. Dein Fortschritt wird gespeichert.\n\nTippe eine Karte an, um sie auszuwählen, dann tippe das Ziel an. Oder ziehe Karten per Drag & Drop auf passende Stapel.\n\nZiel: Lege alle 52 Karten sortiert nach Farbe (Ass → König) auf die vier Foundation-Stapel.",
  "game.helpJourneyKlondike": "Die ewige Reise — Klondike (Ziehe 3)\n\nSpiele dich Schritt für Schritt durch die Sets. Es werden immer 3 Karten vom Stapel gezogen — nur die oberste ist spielbar.\n\nTippe eine Karte an oder ziehe sie per Drag & Drop auf passende Stapel.\n\nZiel: Lege alle 52 Karten sortiert nach Farbe (Ass → König) auf die vier Foundation-Stapel.",
  "game.helpKlondike": "Klondike (Ziehe 3)\n\nJeden Tag gibt es ein neues Set. Es werden immer 3 Karten vom Stapel gezogen — nur die oberste ist spielbar.\n\nTippe eine Karte an oder ziehe sie per Drag & Drop auf passende Stapel.\n\nZiel: Lege alle 52 Karten sortiert nach Farbe (Ass → König) auf die vier Foundation-Stapel.",
  "game.helpDefault": "Solitaire (Klondike)\n\nTippe eine Karte an, um sie auszuwählen, dann tippe das Ziel an. Oder ziehe Karten per Drag & Drop auf passende Stapel.\n\nIm Tableau legst du Karten abwechselnd Rot/Schwarz in absteigender Reihenfolge.\n\nZiel: Lege alle 52 Karten sortiert nach Farbe (Ass → König) auf die vier Foundation-Stapel.",
  "game.moves": "Züge",

  // ── Ende-Overlay ─────────────────────────────────────────
  "end.title": "Set beendet",
  "end.timeBonusReduced": "Zeitbonus (÷{{divisor}})",
  "end.foundation": "Foundation ({{count}} Karten)",
  "end.flips": "Aufdeckungen ({{count}}×)",
  "end.rotations": "Rotationen ({{count}}× extra)",
  "end.shakes": "Shakes ({{count}}×)",
  "end.total": "Gesamt",
  "end.saving": "Speichere…",
  "end.rank": "🏆 Platz {{rank}}",
  "end.saved": "Gespeichert",
  "end.showLeaderboard": "Rangliste anzeigen",
  "end.nextSet": "Nächstes Set ›",
  "end.retry": "Nochmal",

  // ── Gewinn-Overlay ───────────────────────────────────────
  "win.title": "Gewonnen!",
  "win.timeBonus": "Zeitbonus ({{seconds}}s)",
  "win.foundation52": "Foundation (52 Karten)",
  "win.winBonus": "Gewinn-Bonus",

  // ── LoginPage ────────────────────────────────────────────
  "auth.email": "E-Mail",
  "auth.emailPlaceholder": "deine@email.de",
  "auth.password": "Passwort",
  "auth.passwordPlaceholder": "mind. 6 Zeichen",
  "auth.passwordLoginPlaceholder": "Dein Passwort",
  "auth.loading": "Bitte warten…",
  "auth.register": "Registrieren",
  "auth.loginBtn": "Anmelden",
  "auth.or": "oder",
  "auth.googleSoon": "Demnächst verfügbar",
  "auth.googleLogin": "Mit Google anmelden",
  "auth.googleComingSoon": "(demnächst)",
  "auth.loginTab": "Anmelden",
  "auth.registerTab": "Registrieren",
  "auth.playWithout": "Ohne Anmeldung spielen →",

  // ── Auth-Fehler (useAuthStore) ───────────────────────────
  "auth.error.usernameInvalid": "Username: max. 10 Zeichen, nur Buchstaben und Zahlen.",
  "auth.error.loginFailed": "E-Mail oder Passwort falsch.",
  "auth.error.notLoggedIn": "Nicht eingeloggt.",
  "auth.error.wrongPassword": "Aktuelles Passwort ist falsch.",

  // ── UsernameField ────────────────────────────────────────
  "username.label": "Username",
  "username.placeholder": "z.B. max99",
  "username.idle": "max. 10 Zeichen, nur Buchstaben & Zahlen",
  "username.checking": "Wird geprüft…",
  "username.available": "✓ Verfügbar",
  "username.taken": "✗ Bereits vergeben",
  "username.invalid": "✗ Nur Buchstaben/Zahlen, max. 10 Zeichen",

  // ── SettingsPage ─────────────────────────────────────────
  "settings.back": "← Zurück",
  "settings.title": "Einstellungen",
  "settings.account": "Konto",
  "settings.username": "Benutzername",
  "settings.changeEmail": "E-Mail ändern",
  "settings.currentEmail": "(aktuell: {{email}})",
  "settings.newEmail": "Neue E-Mail-Adresse",
  "settings.change": "Ändern",
  "settings.emailSent": "✓ Bestätigungs-E-Mail gesendet — bitte prüfe dein Postfach.",
  "settings.changePassword": "Passwort ändern",
  "settings.currentPassword": "Aktuelles Passwort",
  "settings.newPassword": "Neues Passwort",
  "settings.passwordChanged": "✓ Passwort erfolgreich geändert.",
  "settings.loginToManage": "um Kontoeinstellungen zu verwalten.",
  "settings.graphics": "Grafik",
  "settings.sessionOnly": "Einstellungen gelten nur für diese Sitzung.",
  "settings.loginToSave": "um sie dauerhaft zu speichern.",
  "settings.cardSet": "Kartenset",
  "settings.cardBack": "Kartenrücken",
  "settings.tableColor": "Tischfarbe",
  "settings.saving": "Speichert…",
  "settings.saveGraphics": "Grafik speichern",
  "settings.graphicsSaved": "✓ Gespeichert",
  "settings.leftHanded": "Linkshänder-Modus",
  "settings.leftHandedDesc": "Stock/Waste rechts, Foundation links",
  "settings.autoAce": "Automatisches Ass",
  "settings.autoAceDesc": "Aufgedeckte Asse fliegen automatisch auf die Foundation",
  "settings.animationSpeed": "Fluggeschwindigkeit",

  // ── Set-Picker ─────────────────────────────────────────────
  "game.pickSetTitle": "Set auswählen",
  "game.pickSetNext": "Nächstes Set ({{next}})",
  "game.pickSetOr": "oder Set-Nr. eingeben",
  "game.pickSetRange": "Set 1 – {{max}}",
  "game.pickSetGo": "Los",
  "game.pickSetPlaceholder": "Set Nr.",
  "settings.speedSlow": "Langsam",
  "settings.speedNormal": "Normal",
  "settings.speedFast": "Schnell",

  // ── LeaderboardPage ──────────────────────────────────────
  "lb.noGame": "Kein Spiel angegeben.",
  "lb.back": "← Zurück",
  "lb.title": "RANGLISTE",
  "lb.gameNumber": "Spiel #{{seed}}",
  "lb.play": "Spielen",
  "lb.loading": "Lade Rangliste…",
  "game.shuffling": "Karten mischen…",
  "lb.noEntries": "Noch keine Einträge",
  "lb.beFirst": "Sei der Erste, der dieses Spiel gewinnt!",
  "lb.rank": "#",
  "lb.username": "Username",
  "lb.score": "Punkte",
  "lb.time": "Zeit",
  "lb.movesHeader": "Züge",
  "lb.you": "(du)",
  "lb.error": "Laden fehlgeschlagen",
  "lb.retry": "Nochmal versuchen",
  "lb.footer": "Top {{count}} · sortiert nach Punkten",
  "lb.yourRank": "Deine Platzierung",
  "lb.rankOfTotal": "Platz {{rank}} von {{total}}",

  // ── Tischfarben (config.ts) ──────────────────────────────
  "bg.casinoGreen": "Casino Green",
  "bg.filzGreen": "Dark Green",
  "bg.waldGreen": "Waldgrün",
  "bg.pokerFelt": "Poker-Felt",
  "bg.electricPurple": "Electric Purple",
  "bg.rebeccaPurple": "RebeccaPurple",

  // ── ProfilePage (Statistik) ──────────────────────────────
  "profile.back": "← Zurück",
  "profile.title": "Statistik",
  "profile.daily": "Set des Tages",
  "profile.journey": "Die ewige Reise",
  "profile.weekly": "Weekly",
  "profile.tower": "Tower of Babel",
  "profile.klondike": "Klondike",
  "profile.comingSoon": "Bald verfügbar",
  "profile.noData": "Keine Spiele in diesem Monat",
  "profile.won": "Gewonnen",
  "profile.lost": "Nicht geschafft",
  "profile.notPlayed": "Nicht gespielt",

  // ── LogoutPage ──────────────────────────────────────────────
  "logout.title": "Vielen Dank für deinen Besuch!",
  "logout.subtitle": "Du wurdest erfolgreich abgemeldet.",
  "logout.continue": "Weiter spielen",

  // ── Kartenset-Namen (CardSetContext) ──────────────────────
  "cardset.classic3": "Classic 3 (Large)",
  "cardset.classic4": "Classic 4 (Generated)",
  "cardset.classic5": "Classic 5 (Kein Spiegel)",
} as const;

export type TranslationKey = keyof typeof de;
